<template>
  <div>
    <el-dialog title="视频" :visible.sync="dialogVisible" width="30%" @before-close="dialogVisible = false"
      @close="guanbi">
      <div class="video-container">
        <video ref="myVideo" :src="videoUrl" width="100%" height="400px" controls></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {

  watch: {
  },
  data() {
    return {
      dialogVisible: false,
      videoUrl: ""
    };
  },
  methods: {
    showDialog(e) {
      this.dialogVisible = true;
      this.videoUrl = e;
    },
    guanbi() {
      this.$refs.myVideo.pause();
    }
  }
};
</script>

<style lang="scss" scoped>
.video-container {
  width: 100%;
}
</style>